<template lang="pug">
.order-data-novelties(:class="{ 'order-pack': showProductDetail }")
  OrderDataNoveltyBadge

  .order-data-novelties__sticky
    template(v-if="!showProductDetail")
      p.order-data-novelties__count(v-if="!listLoading")
        b {{ noveltyRows.length }}
        |  {{ noveltyRows.length === 1 ? 'novedad pendiente' : 'novedades pendientes' }}

      .order-data-novelties__actions(v-if="!listLoading && hasSelection")
        .order-data-novelties__toolbar
          shActionButton(
            :action="generateRemit"
            text="Generar remite"
            textRunning="Generando remite"
            :normalColor="true"
          )
          shActionButton(
            v-if="hasSelectedWithRemit"
            :action="printRemit"
            text="Imprimir remite"
            textRunning="Imprimiendo remite"
            :normalColor="true"
          )
          shActionButton(
            v-if="hasSelectedWithGuide"
            :action="printGuides"
            text="Imprimir guías"
            textRunning="Imprimiendo guías"
            :normalColor="true"
          )

        p.order-data-novelties__selected-count
          b {{ selectedCount }}
          |  {{ selectedCount === 1 ? 'orden seleccionada' : 'órdenes seleccionadas' }}

      .order-pack__header.order-pack__row
        .order-pack__cell.order-pack__col-check
          shCheckbox(
            :value="allSelected"
            @input="toggleSelectAll"
            icon-color="var(--color-placeholder)"
            icon-size="1.75rem"
          )
        .order-pack__cell.order-pack__col-number Orden
        .order-pack__cell.order-pack__col-status Estado
        .order-pack__cell.order-pack__col-name Nombre
        .order-pack__cell.order-pack__col-location Ciudad
        .order-pack__cell.order-pack__col-date Fecha
        .order-pack__cell.order-pack__col-novelty Novedad
        .order-pack__cell.order-pack__col-novelty-package Tamaño
        .order-pack__cell.order-pack__col-novelty-quote Cotización
        .order-pack__cell.order-pack__col-novelty-actions
        .order-pack__cell.order-pack__col-novelty-close

    template(v-else)
      .order-pack__header.order-pack__row.order-pack__row--detail
        .order-pack__cell.order-pack__col-number Orden
        .order-pack__cell.order-pack__col-status Estado
        .order-pack__cell.order-pack__col-name Nombre
        .order-pack__cell.order-pack__col-location Ciudad
        .order-pack__cell.order-pack__col-date Fecha
        .order-pack__cell.order-pack__col-novelty Novedad

      .order-pack__list.order-pack__list--detail(v-if="productDetailOrder")
        PackListOrderRow(
          :item="productDetailOrder"
          is-detail
          :name="shortName(productDetailOrder.name)"
          :location="cutValue(productDetailOrder.location)"
          :date-label="recordDateLabel(productDetailOrder)"
          :status-label="statusLabel(productDetailOrder.status)"
          :status-style="statusStyle(productDetailOrder.status)"
          :novelty-tags="productDetailTags"
          hide-remit-column
        )

  .order-data-novelties__body
    template(v-if="!showProductDetail")
      shLoader(:show="listLoading")

      .order-pack__list(v-if="!listLoading && noveltyRows.length")
        .order-data-novelties__row(
          v-for="row in noveltyRows"
          :key="row.key"
          :class="{ 'is-single-action': row.types.length === 1 }"
          @click="onNoveltyRowClick(row)"
        )
          PackListOrderRow(
            :show-check="row.types.includes('data')"
            :item="row.order"
            :selected="row.types.includes('data') && isSelected(row.order.order)"
            :name="shortName(row.order.name)"
            :location="cutValue(row.order.location)"
            :date-label="recordDateLabel(row.order)"
            :status-label="statusLabel(row.order.status)"
            :status-style="statusStyle(row.order.status)"
            :novelty-tags="row.tags"
            hide-remit-column
            show-package-column
            show-quote-column
            :quote-label="dataNoveltyQuoteLabel(row.dataOrder)"
            :show-novelty-actions="row.types.includes('data')"
            :show-novelty-close="row.types.includes('data')"
            @select="setSelected(row.order.order, $event)"
            @novelty-tag="openNoveltyTag(row, $event)"
          )
            template(slot="package")
              PackageSize(
                v-if="row.dataOrder"
                :order="row.dataOrder"
                :opened="openedPackageOrder === row.dataOrder.order"
                @update:opened="setOpenedPackage($event, row.dataOrder)"
                @change="persistDataNoveltyQuote"
                @saved="onPackageSaved"
              )
            template(slot="novelty-actions")
              NoveltyDataActions(
                v-if="row.dataOrder"
                :order="row.dataOrder"
                @refresh="refreshDataOrder(row.dataOrder.order)"
                @need-package="openPackageSize(row.dataOrder, $event)"
              )
            template(slot="novelty-close")
              NoveltyDataClose(
                v-if="row.dataOrder"
                :order="row.dataOrder"
                @closed="onDataNoveltyClosed"
              )

      p.order-data-novelties__empty(v-if="!listLoading && !noveltyRows.length") No hay novedades pendientes en el último mes.

    template(v-else)
      shLoader(:show="productDetailLoading")

      .order-data-novelties__product-detail(v-if="productDetailOrder && !productDetailLoading")
        PackRecordProducts(
          :key="productDetailOrder.order"
          :data-original="productDetailOrder"
          record-type="productChange"
        )
          template(slot="product-change-actions")
            shActionButton(
              :action="openRejectModal"
              text="Rechazar"
              textRunning="Rechazando"
              :normalColor="true"
            )

  OrderNoveltyModal(
    :show="!!selectedDataOrder"
    :order="selectedDataOrder"
    @close="selectedDataOrder = null"
    @refresh="refreshSelectedDataOrder"
  )

  ProductChangeRejectModal(
    :show="rejectModal.show"
    :order="productDetailOrder && productDetailOrder.order"
    :busy="rejectModal.busy"
    @close="rejectModal.show = false"
    @reject="rejectProductChangeAction"
  )

  KeyboardTypingOverlay(
    v-if="showProductDetail"
    :active="true"
    :input-label="overlayInputLabel"
    @submit="onScanSubmit"
  )
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import gql from '@my/graphql'
import gqlOrder from '@/graphql/order'
import gqlCoordinadora from '@/graphql/coordinadora'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'
import router from '@my/router'
import modals from '@my/store/modals'
import shLoader from '@/components/layout/Loader'
import shCheckbox from '@/components/elements/Checkbox'
import shActionButton from '@/components/elements/ActionButton'
import OrderNoveltyModal from '@/components/elements/order/OrderNoveltyModal.vue'
import OrderDataNoveltyBadge from '@/components/elements/order/OrderDataNoveltyBadge.vue'
import NoveltyDataActions from '@/components/elements/order/NoveltyDataActions.vue'
import NoveltyDataClose from '@/components/elements/order/NoveltyDataClose.vue'
import ProductChangeRejectModal from '@/components/elements/order/ProductChangeRejectModal.vue'
import PackageSize from '@/components/elements/PackageSize.vue'
import PackListOrderRow from '@/components/pages/order/pack/PackListOrderRow.vue'
import PackRecordProducts from '@/components/pages/order/pack/PackRecordProducts.vue'
import KeyboardTypingOverlay from '@/components/keyboard/TypingOverlay.vue'
import { recordHasRemit } from '@/helpers/remit'
import { canDownloadDeliveryLabel } from '@/helpers/deliveryMass'
import { mapPackOrder } from '@/store/modules/pack'
import { parsePackSearchInput, parseProductCode } from '@/helpers/packSearch'
import { mergeNoveltyOrder, displayDataNoveltyFreightCost } from '@/helpers/orderNovelty'

export default {
  name: 'OrderDataNovelties',

  mixins: [mFilters, mForm],

  components: {
    shLoader,
    shCheckbox,
    shActionButton,
    OrderNoveltyModal,
    OrderDataNoveltyBadge,
    NoveltyDataActions,
    NoveltyDataClose,
    ProductChangeRejectModal,
    PackageSize,
    PackListOrderRow,
    PackRecordProducts,
    KeyboardTypingOverlay
  },

  data () {
    return {
      selectedDataOrder: null,
      rejectModal: {
        show: false,
        busy: false
      },
      statusSpanish: {
        paid: 'Pagado',
        packed: 'Empacado',
        sent: 'Enviado',
        created: 'Creado',
        approved: 'Aprobado',
        pending: 'Pendiente',
        declined: 'Rechazado',
        delivered: 'Entregado',
        recovered: 'Recuperado'
      },
      audios: {
        beepError: '',
        beep: '',
        error: '',
        product: ''
      },
      sounds: {
        beepError: 'beep_error.mp3',
        beep: 'beep.mp3',
        error: 'error.mp3',
        product: 'product.mp3'
      },
      contentParent: null,
      scrollParent: null,
      resizeHandler: null,
      openedPackageOrder: null,
      pendingPackageAction: null
    }
  },

  computed: {
    ...mapState('orderNovelty', [
      'dataCount',
      'productCount',
      'dataOrders',
      'productOrders',
      'dataLoading',
      'productLoading',
      'dataSelectedOrders',
      'productDetailOrder',
      'productDetailLoading'
    ]),

    listLoading () {
      return this.dataLoading || this.productLoading
    },

    noveltyRows () {
      const byOrder = new Map()

      this.dataOrders.forEach(order => {
        const existing = byOrder.get(order.order) || this.createNoveltyRow(order)
        existing.dataOrder = order
        existing.order = mergeNoveltyOrder(existing.order, order)

        if (!existing.types.includes('data')) {
          existing.types.push('data')
          existing.tags.push({ type: 'data', label: 'Datos', class: 'is-data' })
        }

        byOrder.set(order.order, existing)
      })

      this.productOrders.forEach(order => {
        const existing = byOrder.get(order.order) || this.createNoveltyRow(order)
        existing.productOrder = order
        existing.order = mergeNoveltyOrder(existing.order, order)
        existing.changeLabel = this.productChangeLabel(order)

        if (!existing.types.includes('product')) {
          existing.types.push('product')
          existing.tags.push({
            type: 'product',
            label: 'Producto',
            class: 'is-product',
            count: this.productChangeQuantity(order)
          })
        }

        byOrder.set(order.order, existing)
      })

      return Array.from(byOrder.values()).sort((a, b) => {
        const dateA = new Date(a.order.createdAt || 0).getTime()
        const dateB = new Date(b.order.createdAt || 0).getTime()
        return dateB - dateA
      })
    },

    dataOrderIds () {
      return this.dataOrders.map(orderItem => orderItem.order)
    },

    selectedOrderIds () {
      return Object.keys(this.dataSelectedOrders).filter(order => this.dataSelectedOrders[order])
    },

    selectedCount () {
      return this.selectedOrderIds.length
    },

    hasSelection () {
      return this.selectedCount > 0
    },

    allSelected () {
      if (!this.dataOrderIds.length) return false
      return this.dataOrderIds.every(orderId => this.dataSelectedOrders[orderId])
    },

    hasSelectedWithRemit () {
      return this.selectedOrderIds.some(orderId => {
        const orderItem = this.dataOrders.find(item => item.order === orderId)
        return recordHasRemit(orderItem)
      })
    },

    hasSelectedWithGuide () {
      return this.selectedOrderIds.some(orderId => {
        const orderItem = this.dataOrders.find(item => item.order === orderId)
        return canDownloadDeliveryLabel(orderItem)
      })
    },

    showProductDetail () {
      return !!(this.$route.params.code || this.productDetailOrder || this.productDetailLoading)
    },

    overlayInputLabel () {
      return this.showProductDetail ? 'Producto' : 'Pedido'
    },

    productDetailTags () {
      if (!this.productDetailOrder) return []

      return [{
        type: 'product',
        label: 'Producto',
        class: 'is-product',
        count: this.productChangeQuantity(this.productDetailOrder)
      }]
    }
  },

  watch: {
    dataOrders: {
      deep: true,
      handler (orders) {
        if (!this.selectedDataOrder) return

        const updated = orders.find(item => item.order === this.selectedDataOrder.order)

        if (updated) {
          this.selectedDataOrder = updated
        }
      }
    },

    '$route.fullPath': {
      immediate: true,
      handler () {
        this.syncProductDetailFromRoute()
      }
    },

    productDetailOrder (order) {
      if (!this.showProductDetail) return

      const code = order && order.order
      const currentCode = this.$route.params.code

      if (code && currentCode !== code) {
        this.$router.replace({ name: 'OrderDataNovelties', params: { code } })
      } else if (!code && currentCode) {
        this.closeProductDetail()
      }
    }
  },

  mounted () {
    this.contentParent = this.$el.classList.contains('box')
      ? this.$el
      : this.$el.closest('.content.box')
    this.scrollParent = this.$el.closest('.content-section')

    if (this.contentParent) {
      this.contentParent.classList.add('order-pack-page')
    }
    if (this.scrollParent) {
      this.scrollParent.classList.add('order-pack-scroll')
    }

    this.resizeHandler = () => this.updatePackHeight()
    window.addEventListener('resize', this.resizeHandler)

    this.fetchDataNovelties()
    this.fetchProductChanges()
    this.fetchDataNoveltyCount()
    this.fetchProductChangeCount()

    this.$nextTick(() => this.updatePackHeight())
  },

  updated () {
    this.$nextTick(() => this.updatePackHeight())
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.resizeHandler)

    if (this.contentParent) {
      this.contentParent.classList.remove('order-pack-page')
      this.contentParent.style.height = ''
      this.contentParent.style.maxHeight = ''
    }
    if (this.scrollParent) {
      this.scrollParent.classList.remove('order-pack-scroll')
    }
  },

  methods: {
    ...mapActions('orderNovelty', [
      'fetchDataNovelties',
      'fetchProductChanges',
      'fetchDataNoveltyCount',
      'fetchProductChangeCount',
      'fetchProductChangeDetail',
      'generateNoveltyRemit',
      'rejectProductChange',
      'refreshDataNoveltyOrder',
      'quoteDataNoveltyOrder',
      'generateDataNoveltyGuide',
      'persistDataNoveltyQuote'
    ]),
    ...mapMutations('orderNovelty', {
      setNoveltySelected: 'setNoveltySelected',
      setNoveltyAllSelected: 'setNoveltyAllSelected',
      setProductDetailOrder: 'setProductDetailOrder'
    }),

    updatePackHeight () {
      if (!this.scrollParent || !this.contentParent) return

      const sectionRect = this.scrollParent.getBoundingClientRect()
      const top = this.contentParent.getBoundingClientRect().top
      const height = Math.max(sectionRect.bottom - top, 0)

      this.contentParent.style.height = `${height}px`
      this.contentParent.style.maxHeight = `${height}px`
    },

    syncProductDetailFromRoute () {
      const code = this.$route.params.code

      if (!code) {
        if (this.productDetailOrder) this.setProductDetailOrder(null)
        return
      }

      this.openProductChangeByOrder(decodeURIComponent(code))
    },

    closeProductDetail () {
      this.setProductDetailOrder(null)
      this.$router.replace({ name: 'OrderDataNovelties' })
    },

    openNoveltyRow (row) {
      if (!row || !row.order) return

      if (row.types.includes('data')) {
        this.openDataNovelty(row.dataOrder || row.order)
        return
      }

      this.openProductChange(row.productOrder || row.order)
    },

    onNoveltyRowClick (row) {
      if (!row || row.types.length !== 1) return
      this.openNoveltyRow(row)
    },

    openNoveltyTag (row, type) {
      if (!row) return

      if (type === 'data') {
        this.openDataNovelty(row.dataOrder || row.order)
        return
      }

      if (type === 'product') {
        this.openProductChange(row.productOrder || row.order)
      }
    },

    createNoveltyRow (order) {
      return {
        key: order.order,
        order,
        dataOrder: null,
        productOrder: null,
        types: [],
        tags: [],
        changeLabel: null
      }
    },

    isSelected (order) {
      return !!this.dataSelectedOrders[order]
    },

    setSelected (order, value) {
      this.setNoveltySelected({ order, value })
    },

    toggleSelectAll (value) {
      this.setNoveltyAllSelected({
        orderIds: this.dataOrderIds,
        value
      })
    },

    shortName (value) {
      if (!value) return ''
      const names = value.split(' ')
      return names[0] || names[1] || ''
    },

    cutValue (value) {
      if (!value) return ''
      const maxLength = 8
      return value.slice(0, maxLength) + (value.length > maxLength ? '...' : '')
    },

    recordDateLabel (item) {
      return `${this.dateName(item.createdAt)} - ${this.time(item.createdAt)}`
    },

    statusLabel (status) {
      return this.statusSpanish[status] || status
    },

    statusStyle (status) {
      const colors = this.colorsStatus[status]
      if (!colors) return {}
      return {
        background: colors.background,
        color: colors.color
      }
    },

    productChangeLabel (orderItem) {
      const change = orderItem && orderItem.productChange
      if (!change) return '—'
      return `${change.from} → ${change.to}`
    },

    productChangeQuantity (orderItem) {
      const item = orderItem && orderItem.productChange && orderItem.productChange.item
      if (!item || !Array.isArray(item.quantityCart)) return 1

      const total = item.quantityCart.reduce((sum, qty) => sum + (Number(qty) || 0), 0)
      return total > 0 ? total : 1
    },

    dataNoveltyQuoteLabel (orderItem) {
      if (!orderItem) return ''
      const cost = displayDataNoveltyFreightCost(orderItem)
      return cost ? this.money(cost) : ''
    },

    setOpenedPackage (open, order) {
      this.openedPackageOrder = open && order ? order.order : null
      if (!open) this.pendingPackageAction = null
    },

    openPackageSize (order, action = null) {
      if (!order) return
      this.pendingPackageAction = action
      this.openedPackageOrder = order.order
    },

    async onPackageSaved ({ order, packageDimensions }) {
      const action = this.pendingPackageAction
      this.pendingPackageAction = null
      this.openedPackageOrder = null

      if (!order || !action) return

      const current = this.dataOrders.find(item => item.order === order.order) || order

      if (action === 'quote') {
        await this.quoteDataNoveltyOrder({ order: current, packageDimensions })
        return
      }

      if (action === 'guide') {
        await this.generateDataNoveltyGuide({ order: current, packageDimensions, collectFreight: false })
        return
      }

      if (action === 'collect') {
        await this.generateDataNoveltyGuide({ order: current, packageDimensions, collectFreight: true })
      }
    },

    openDataNovelty (orderItem) {
      this.selectedDataOrder = orderItem
    },

    refreshSelectedDataOrder () {
      if (!this.selectedDataOrder) return

      const updated = this.dataOrders.find(item => item.order === this.selectedDataOrder.order)

      if (updated) {
        this.selectedDataOrder = updated
      } else {
        this.selectedDataOrder = null
      }
    },

    refreshDataOrder (orderId) {
      if (!orderId) return
      this.refreshDataNoveltyOrder(orderId)
    },

    onDataNoveltyClosed () {
      this.fetchDataNoveltyCount()
    },

    openProductChange (orderItem) {
      if (!orderItem || !orderItem.order) return

      if (this.$route.params.code === orderItem.order) {
        return this.openProductChangeByOrder(orderItem.order)
      }

      this.$router.push({
        name: 'OrderDataNovelties',
        params: { code: orderItem.order }
      })
    },

    async openProductChangeByOrder (orderId) {
      if (!orderId) return

      const needsFetch = !this.productDetailOrder ||
        this.productDetailOrder.order !== orderId ||
        !this.productDetailOrder.productChange ||
        !this.productDetailOrder.productChange.item

      if (!needsFetch) return

      const fromList = this.productOrders.find(item => item.order === orderId)
      if (fromList) {
        this.setProductDetailOrder(fromList)
      }

      const result = await this.fetchProductChangeDetail(orderId)

      if (result && result.success) return

      this.playSoundError()

      if (result && result.noChange) {
        modals.showMessage({
          message: `La orden ${orderId} no tiene un cambio de producto pendiente`,
          type: 'error'
        })
      } else if (result && result.notFound) {
        modals.showMessage({
          message: `No se encontró la orden ${orderId}`,
          type: 'error'
        })
      } else {
        modals.showMessage({
          message: `No se pudo abrir la orden ${orderId}`,
          type: 'error'
        })
      }

      this.closeProductDetail()
    },

    openRejectModal () {
      this.rejectModal.show = true
    },

    async rejectProductChangeAction (reason) {
      if (!this.productDetailOrder || !this.productDetailOrder.order) return

      this.rejectModal.busy = true

      try {
        const success = await this.rejectProductChange({
          order: this.productDetailOrder.order,
          reason
        })

        if (success) {
          this.rejectModal.show = false
          this.closeProductDetail()
          await this.fetchProductChanges()
          await this.fetchProductChangeCount()
        }
      } finally {
        this.rejectModal.busy = false
      }
    },

    generateRemit () {
      return this.generateNoveltyRemit({ orderIds: this.selectedOrderIds })
    },

    printRemit () {
      const orders = this.selectedOrderIds
        .map(orderId => this.dataOrders.find(item => item.order === orderId))
        .filter(recordHasRemit)
        .map(mapPackOrder)

      if (!orders.length) return Promise.resolve()

      this.$store.commit('setPrintReturnAddress', {
        orders,
        remitOnly: true
      })
      router.goToPrintReturnAddress()
    },

    getApiUrl () {
      let domain = window.location.hostname
      if (domain === 'pika.sahet.co') domain = 'https://db.sahet.co'
      if (domain === 'localhost') domain = 'http://localhost:3000'
      return domain
    },

    async printGuides () {
      const idsRemission = this.selectedOrderIds
        .map(orderId => this.dataOrders.find(item => item.order === orderId))
        .filter(canDownloadDeliveryLabel)
        .map(orderItem => orderItem.deliveries.at(-1).idRemission)

      if (!idsRemission.length) {
        modals.showMessage({
          message: 'No hay guías generadas en las órdenes seleccionadas',
          type: 'error'
        })
        return
      }

      const errors = []
      const response = await gql.mutate(
        gqlCoordinadora.GENERATE_LABELS_COORDINADORA,
        { idsRemission },
        false,
        errors
      )

      if (errors.length || !response) {
        modals.showMessage({
          message: errors[0] || 'No se pudieron imprimir las guías',
          type: 'error'
        })
        return
      }

      const namePdf = response.data.generateLabelsCoordinadora
      window.open(`${this.getApiUrl()}/coordinadora/labelsJoined/${namePdf}`, '_blank')
    },

    playSoundProduct () {
      if (!this.audios.beep) {
        this.audios.beep = this.playSound(this.sounds.beep)
      } else {
        this.audios.beep.play()
      }

      if (!this.audios.product) {
        this.audios.product = this.playSound(this.sounds.product)
      } else {
        this.audios.product.play()
      }
    },

    playSoundError () {
      if (!this.audios.beepError) {
        this.audios.beepError = this.playSound(this.sounds.beepError)
      } else {
        this.audios.beepError.play()
      }

      if (!this.audios.error) {
        this.audios.error = this.playSound(this.sounds.error)
      } else {
        this.audios.error.play()
      }
    },

    async checkProductChangeCode (codeString) {
      if (!this.productDetailOrder || !this.productDetailOrder.productChange) {
        modals.showMessage({
          message: 'Selecciona primero una orden con cambio de producto',
          type: 'error'
        })
        this.playSoundError()
        return
      }

      const product = parseProductCode(codeString)

      if (!product) {
        this.playSoundError()
        return
      }

      const expectedProduct = this.productDetailOrder.productChange.product
      const expectedSize = this.productDetailOrder.productChange.to

      if (product.product !== expectedProduct || product.size !== expectedSize) {
        modals.showMessage({
          message: `El producto escaneado no coincide con el cambio pendiente (${expectedProduct} · ${expectedSize})`,
          type: 'error'
        })
        this.playSoundError()
        return
      }

      const response = await gql.mutate(gqlOrder.CHECK_PRODUCT_CHANGE_ORDER, {
        order: this.productDetailOrder.order,
        product: product.product,
        size: product.size
      })

      if (response) {
        this.playSoundProduct()
        await this.fetchProductChangeDetail(this.productDetailOrder.order)
        await this.fetchProductChanges()
        await this.fetchProductChangeCount()
      } else {
        this.playSoundError()
      }
    },

    async onScanSubmit (value) {
      const parsed = parsePackSearchInput(value)
      if (!parsed) return

      if (parsed.type === 'product') {
        return this.checkProductChangeCode(parsed.productCode)
      }

      if (parsed.type === 'order') {
        if (this.$route.params.code === parsed.queryId) {
          return this.openProductChangeByOrder(parsed.queryId)
        }

        this.$router.replace({
          name: 'OrderDataNovelties',
          params: { code: parsed.queryId }
        })
        return
      }

      modals.showMessage({
        message: 'Escanea una orden (s…) o un código de producto',
        type: 'error'
      })
      this.playSoundError()
    }
  }
}
</script>

<style lang="stylus" scoped>
.order-data-novelties
  display flex
  flex-direction column
  flex 1
  min-height 0
  width 100%
  height 100%

.order-data-novelties__sticky
  flex-shrink 0
  z-index 5
  background var(--background-principal)

.order-data-novelties__body
  flex 1
  min-height 0
  overflow-y auto
  -webkit-overflow-scrolling touch
  padding-bottom 6rem

.order-data-novelties__count
  margin 0 0 1.25rem .3rem
  font-size 1.1rem
  text-transform lowercase

.order-data-novelties__count b
  font-weight 700

.order-data-novelties__actions
  margin-bottom 1rem

.order-data-novelties__toolbar
  display flex
  flex-wrap wrap
  gap .75rem

.order-data-novelties__selected-count
  margin .75rem 0 0 .3rem
  font-size .95rem
  text-transform lowercase

.order-data-novelties__empty
  margin 2rem .3rem 0
  font-size 1rem
  opacity .7

.order-data-novelties__row
  cursor default

  &.is-single-action
    cursor pointer

    &:active
      opacity .85

  >>> .order-pack__col-check
    pointer-events auto

  >>> .order-pack__col-novelty-package
    pointer-events auto

  >>> .order-pack__col-novelty-quote
    pointer-events auto

  >>> .order-pack__col-novelty-actions
    pointer-events auto

  >>> .order-pack__col-novelty-close
    pointer-events auto

.order-data-novelties__product-detail
  padding 0 .3rem 2rem
  margin-top 2.5rem
</style>

<style lang="stylus">
@import '~@/stylus/product.styl'

.products-order-container
  display flex
  justify-content flex-start
  flex-wrap wrap
  gap 3em 1em
  margin 0
  width 100%

.order-data-novelties.order-pack .pack-record-products__item
  flex-basis 100%
  box-sizing border-box

@media (min-width: 769px)
  .order-data-novelties.order-pack .product-container,
  .order-data-novelties.order-pack .pack-record-products__item
    flex-basis calc(25% - .75em)

.content-section.order-pack-scroll
  overflow hidden

.content.box.order-pack-page
  overflow hidden
  display flex
  flex-direction column
  box-sizing border-box

.order-data-novelties
  .order-pack__header,
  .order-pack__row
    display flex
    align-items center
    width 100%
    box-sizing border-box
    border-bottom 1px solid rgba(0, 0, 0, 0.08)
    padding 1.25rem 0
    text-align left
    font-size 1.15rem

  .order-pack__header
    padding .5rem 0

  .order-pack__header.order-pack__row--detail
    margin-top 1rem

  .order-pack__list--detail
    margin-bottom 0

  .order-pack__cell
    box-sizing border-box
    padding-right .5em
    overflow hidden
    text-overflow ellipsis
    min-width 0

  .order-pack__header .order-pack__cell
    font-weight 400
    color var(--color-placeholder)
    text-transform uppercase

  .order-pack__col-check
    flex 0 0 2.75rem

  .order-pack__col-number
    flex 0 0 6rem

  .order-pack__col-status
    flex 0 0 12rem
    display flex
    align-items center
    gap .35em

  .order-pack__col-name
    flex 0 0 6rem

  .order-pack__col-location
    flex 0 0 7rem

  .order-pack__col-date
    flex 1 1 auto

  .order-pack__header.order-pack__row--detail,
  .order-pack__list--detail .order-pack__row
    .order-pack__col-number
      flex 0 0 6rem

    .order-pack__col-status
      flex 0 0 12rem

    .order-pack__col-name
      flex 0 0 6rem

    .order-pack__col-location
      flex 0 0 7rem

    .order-pack__col-date
      flex 0 0 8rem

    .order-pack__col-novelty
      flex 0 0 9.5rem
      display flex
      justify-content flex-end
      overflow visible

  .order-pack__col-novelty
    flex 0 0 9.5rem
    display flex
    justify-content flex-end

  .order-pack__col-novelty-package
    flex 0 0 6.5rem
    display flex
    flex-direction column
    align-items flex-start
    justify-content center
    overflow visible
    min-width 6.5rem
    margin-left 2.5rem
    padding-right 1rem

  >>> .order-pack__col-novelty-package .package-label
    min-width 3rem
    font-size .9rem

  >>> .order-pack__col-novelty-package .package-dimensions-summary
    max-width 100%
    font-size .7rem

  .order-pack__col-novelty-quote
    flex 0 0 9rem
    display flex
    justify-content flex-end
    white-space nowrap
    overflow visible
    text-overflow clip
    min-width 9rem

  .order-pack__col-novelty-actions
    flex 0 0 12rem
    display flex
    justify-content flex-end
    min-width 0
    padding-right 2rem

  .order-pack__col-novelty-close
    flex 0 0 11rem
    display flex
    justify-content flex-end
    white-space nowrap
    overflow visible
    text-overflow clip
    min-width 11rem
    padding-right .5em

  @media (min-width: 769px)
    .order-pack__col-number
      flex 0 0 6.5rem

    .order-pack__col-name
      flex 0 0 10rem

    .order-pack__col-location
      flex 0 0 8rem

    .order-pack__header.order-pack__row--detail,
    .order-pack__list--detail .order-pack__row
      .order-pack__col-number
        flex 0 0 6.5rem

      .order-pack__col-name
        flex 0 0 10rem

      .order-pack__col-location
        flex 0 0 8rem

      .order-pack__col-date
        flex 0 0 11rem

      .order-pack__col-novelty
        flex 0 0 11rem

    .order-pack__col-date
      flex 0 0 11rem

    .order-pack__col-novelty
      flex 0 0 11rem

    .order-pack__col-novelty-quote
      flex 0 0 10rem
      min-width 10rem

    .order-pack__col-novelty-actions
      flex 0 0 14rem
      padding-right 2rem

    .order-pack__col-novelty-close
      flex 0 0 11.5rem
      min-width 11.5rem

.order-pack__novelty-tags
  display inline-flex
  align-items center
  justify-content flex-end
  flex-wrap nowrap
  gap .4rem

.order-pack__novelty-tag
  display inline-flex
  align-items center
  gap .3rem
  padding .2rem .55rem
  border none
  border-radius 999px
  font-size .78rem
  font-weight 600
  line-height 1.2
  white-space nowrap
  cursor pointer
  -webkit-tap-highlight-color transparent

  &:active
    opacity .85

  &.is-data
    background rgba(230, 126, 34, .15)
    color #e67e22

  &.is-product
    background rgba(192, 57, 43, .12)
    color var(--color-red, #c0392b)

.order-pack__novelty-tag-count
  font-weight 700
  opacity .95
</style>



// WEBPACK FOOTER //
// src/components/pages/order/novelties/DataNovelties.vue